import { Params } from '@angular/router';

export class SaveFilterParamQueriesInCache {
  static readonly type = '[FilterSettings]  SaveFilterParamQueriesInCache';
  constructor(
    public userId: string,
    public filterParamQueries: Params,
  ) {}
}
